// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__22Vd8","dragIcon":"SortableItem_dragIcon__1f0SL","disabled":"SortableItem_disabled__3YqNi"};